module.exports = __webpack_public_path__ + "img/table-error.80ae8e98.svg";